export const mapGetCountries = (response) => response
  .map(({ id, countryName, destination }) => ({
    id,
    label: countryName,
    continent: destination
  }))
